module.exports = __webpack_public_path__ + "static/media/2_of_hearts.1be90ac8.png";